import React from 'react'

import HeroImg from '../src/Assests/Rise Images/header visual.png'


export default function SectioOne() {
  return (
    <>
    <br></br><br></br>
        <div className='sectionOne container d-flex justify-content-center align-items-center flex-column' >
        <img style={{width:"60%"}} src={HeroImg}/> <br></br><br></br>
        <h2 style={{fontWeight:'lighter', color:"#014651"}}>A cobranded Prepaid</h2>
        <h1 style={{fontWeight:'bolder', color:"#014651"}}>Payment Card</h1>
        <h3 style={{color:"#014651"}} >Paired with a user-friendly Mobile Application</h3>
        <p style={{textAlign:"center"}}>Tailor-made for the dynamic youth residing
within gated communities</p>
  
<div className="btn-sec-1 col-4  d-flex justify-content-center align-items-center ">
 
          <button style={{background:"#d9ec6e",color:" #00927b", border:'none', fontWeight:"bolder"}}>  Get Started</button>
        </div>

        </div>
        <br/>
        <hr/>
    </>
  )
}
